'use strict';

export default class SearchCompare extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpened: false,
            activeBlock: this.showBarometer() ? 1 : 2,
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {type, barometer} = this.props;
        const {isOpened, activeBlock} = this.state;
        if(prevProps.type !== type && type === 'planes' && isOpened) {
            $(".compare__blocks").show();
        }

        const prevShowBarometer = this.showBarometer(prevProps);
        const showBarometer = this.showBarometer();

        if(type === 'planes' && showBarometer) {
            this.initSwiper();
        }
        if(!prevShowBarometer && showBarometer && activeBlock > 1) {
            this.setState({activeBlock: 1});
        }
    }

    initSwiper() {
        new Swiper(".graph-vals .swiper", {
            slidesPerView: 6,
            spaceBetween: 10,
            initialSlide: 5,
            navigation: {
                nextEl: ".graph-vals__next",
                prevEl: ".graph-vals__prev",
            },
        });

        $(".graph-value").on("mouseenter", function () {
            const data = $(this).attr("data-tooltip"),
                posx = $(this).offset().top,
                posy = $(this).offset().left,
                col = $(this).index();

            if (data === undefined) return

            $(".graph").append('<div class="graph-val__tooltip border-color' + col + '" style="top:' + posx + 'px;left:' + posy + 'px">' + data + '</div>')

            if(col === 0)  $(".graph-val__tooltip").addClass("pos-left")
            if(col === 1) $(".graph-val__tooltip").addClass("pos-left")
            if(col === 4) $(".graph-val__tooltip").addClass("pos-right")
            if(col === 5) $(".graph-val__tooltip").addClass("pos-right")
        }).on("mouseleave", function () {
            $('.graph-val__tooltip').remove()
        })
    }

    handleToggleOpen(e, newIsOpened = null) {
        if(e) e.preventDefault();
        const isOpened = newIsOpened !== null ? newIsOpened : !this.state.isOpened;
        this.setState({isOpened}, () => {
            if(!isOpened) {
                $(".compare__blocks").stop(true, true).slideUp()
            } else {
                $(".compare__blocks").stop(true,true).slideDown()
            }
        });
    }

    handleChangeBlock(e, activeBlock) {
        e.preventDefault();
        this.setState({activeBlock})
        this.handleToggleOpen(null, true);
    }

    showBarometer(props) {
        const {barometer} = props ? props : this.props;
        return !!barometer && !barometer.empty;
    }

    render() {
        const {type, classes, barometer} = this.props;
        const {isOpened, activeBlock} = this.state;

        if(type !== 'planes') return null;

        const showBarometer = this.showBarometer();

        return <div className="compare">
            <div className="compare-top">
                <a href='#' className={clsx('compare-link', {active: isOpened})} onClick={e => this.handleToggleOpen(e)}>{tMsg('Сравнение классов')}</a>
                <div className="compare-tabs">
                    {showBarometer && <a href='#' className={clsx({active: activeBlock === 1})} onClick={e => this.handleChangeBlock(e, 1)}>{tMsg('Цена')}</a>}
                    <a href='#' className={clsx({active: activeBlock === 2})} onClick={e => this.handleChangeBlock(e, 2)}>{tMsg('Количество мест')}</a>
                    <a href='#' className={clsx({active: activeBlock === 3})} onClick={e => this.handleChangeBlock(e, 3)}>{tMsg('Объем багажника')}</a>
                    <a href='#' className={clsx({active: activeBlock === 4})} onClick={e => this.handleChangeBlock(e, 4)}>{tMsg('Объем салона')}</a>
                </div>
            </div>
            <div className="compare__blocks">
                <div className="compare__tab" style={{display: activeBlock === 1 ? 'block' : 'none'}}>
                    {showBarometer && <div className="graph">
                        <div className="graph-row">
                            <div className="graph-titlecol">
                                <div className="graph-titlecol-title">
                                    {tMsg('Среднегодовая цена')}
                                </div>
                                {[...classes].reverse().map((item, index) => {
                                    const key = `searchCompareBarometerClassReverse${item.id}`;
                                    return <div key={key} className="graph-titlecol__row">
                                        <div className={`graph-price graph-price-val${index + 1}`}>
                                            {barometer.classes[item.id].year.formatPrice(barometer.currency)}
                                        </div>
                                        <span>
                                        {item.title}
                                            {item.examples && <span className="graph-planes__tooltip">
                                            {item.examples.map((example, index) => {
                                                return <span key={`${key}Example${index}`}>{example}</span>
                                            })}
                                            <span>...</span>
                                        </span>}
                                    </span>
                                    </div>
                                })}
                            </div>
                            <div className="graph-vals">
                                <a href="#" className="graph-vals__prev"></a>
                                <a href="#" className="graph-vals__next"></a>
                                <div className="swiper">
                                    <div className="swiper-wrapper">
                                        {barometer.months.map((month, index) => {
                                            const key = `searchCompareBarometerMonth${index}`;
                                            return <div key={key} className="swiper-slide">
                                                <div className="graph-val__col">
                                                    <div className="graph-val__title">{month.title} <span>{month.year}</span></div>
                                                    <div className="graph-val__row">
                                                        {classes.map((item, index) => {
                                                            const key = `searchCompareBarometerMonthClass${item.id}`;
                                                            return <div key={key}
                                                                className={`graph-value graph-value${!!month.classes[item.id].price ? (classes.length - index) : 7}`}
                                                                style={{height: `${month.classes[item.id].percent}%`}}
                                                                data-tooltip={month.classes[item.id].price}
                                                            />
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
                <div className="compare__tab" style={{display: activeBlock === 2 ? 'block' : 'none'}}>
                    <div className="nl-scheme__row">
                        {classes.map((item, index) => {
                            const key = `searchCompareSeatsClass${item.id}`;
                            return <div key={key} className="nl-scheme__item">
                                <div className="nl-scheme__count">
                                    <span>{item.seats}</span>
                                    {item.seats_text}
                                </div>
                                <div className="nl-scheme__count-img">
                                    <img src={`${themeDir}/images/svg/count-icon${index + 1}.svg`} alt=""/>
                                </div>
                                <div className="nl-scheme__item-title">
                                    {item.title}
                                </div>
                            </div>
                        })}
                    </div>
                </div>
                <div className="compare__tab" style={{display: activeBlock === 3 ? 'block' : 'none'}}>
                    <div className="nl-scheme__row">
                        {classes.map((item, index) => {
                            const key = `searchCompareTrunkClass${item.id}`;
                            return <div key={key} className="nl-scheme__bag">
                                <div className="nl-scheme__bag-title">
                                    {item.title}
                                </div>
                                <div className="nl-scheme__bag-value">
                                    <div className="nl-scheme__bag-value-title">
                                        <span>{tMsg('объем')}</span>
                                        <div dangerouslySetInnerHTML={{__html: item.trunk_volume}}></div>
                                    </div>
                                    <div
                                        className={`nl-scheme__bag-value-progress value-progress${6 - index}`}
                                        style={{height: `${item.trunk_percent}%`}}
                                    />
                                </div>
                            </div>
                        })}
                    </div>
                </div>
                <div className="compare__tab" style={{display: activeBlock === 4 ? 'block' : 'none'}}>
                    <div className="nl-scheme__row">
                        {classes.map((item, index) => {
                            const key = `searchCompareCabinClass${item.id}`;
                            return <div key={key} className="nl-scheme__item">
                                <div className="nl-scheme__item-desc">
                                    <div className="nl-scheme__item-height">
                                        <span>{tMsg('высота')}</span>
                                        {item.cabin_height}
                                    </div>
                                    <div className="nl-scheme__item-width">
                                        <span>{tMsg('ширина')}</span>
                                        {item.cabin_width}
                                    </div>
                                </div>
                                <div className="nl-scheme__item-img">
                                    <img src={`${themeDir}/images/scheme${index + 1}.png`} alt=""/>
                                </div>
                                <div className="nl-scheme__item-title">
                                    {item.title}
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </div>
    }
}
